import { booleanAttribute, Component, computed, input, output } from '@angular/core';
import { IconHelperDirective } from '@shared/icon-helper/icon-helper.directive';
import { ToastPosition, ToastTone } from './toast.types';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [IconHelperDirective],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class ToastComponent {
  title = input<string | undefined>();
  message = input<string>('');
  tone = input<ToastTone>('neutral');
  position = input<ToastPosition>('top-right');

  showHeader = input<boolean, unknown>(true, { transform: booleanAttribute });
  showMessage = input<boolean, unknown>(true, { transform: booleanAttribute });
  showLeftIcon = input<boolean, unknown>(true, { transform: booleanAttribute });
  isProcess = input<boolean, unknown>(false, { transform: booleanAttribute });

  closeToast = output<void>();

  hostClasses = computed(() => {
    return `app-toast app-toast--${this.tone()} app-toast--${this.position()}`;
  });

  getLeftIconClass = computed(() => {
    const iconName = this.getLeftIconName();
    return `icon-${iconName}`;
  });

  getLeftIconName(): string {
    switch (this.tone()) {
      case 'success':
        return 'check';
      case 'warning':
        return 'warning';
      case 'error':
        return 'warning';
      case 'neutral':
        return this.isProcess() ? 'spinner-dotted' : 'info-circle';
      default:
        return 'info-circle';
    }
  }

  onClose(): void {
    if (!this.isProcess()) {
      this.closeToast.emit();
    }
  }
}
